export const screensize = () => {
  const getScreenSize = () => {
    const width = window.innerWidth;
    if (width < 599) {
      return 'mobile';
    } else if (width < 959) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  };

  let currentScreenSize = getScreenSize();

  const handleResize = () => {
    const newScreenSize = getScreenSize();
    if (newScreenSize !== currentScreenSize) {
      currentScreenSize = newScreenSize;
    }
  };

  window.addEventListener('resize', handleResize);

  return () => currentScreenSize; // Return a function instead of the value directly
};
